import { useCallback } from 'react';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { EERIE, THUNDERDOME, THUNDERDOME_LIGHT } from 'HubStyleTokens/colors';
import UIBox from 'UIComponents/layout/UIBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledRow = styled.li.withConfig({
  displayName: "EPSpotlightSuggestion__StyledRow",
  componentId: "sc-1a2ljob-0"
})(["border-radius:12px;height:42px;cursor:pointer;&:hover,&[aria-selected='true']{background-color:", ";.row-text{color:", ";}}"], THUNDERDOME_LIGHT, THUNDERDOME);
export const EPSpotlightSuggestion = ({
  isSelected,
  onClick,
  suggestion
}) => {
  const {
    icon,
    label
  } = suggestion;
  const handleClick = useCallback(() => {
    onClick(suggestion);
  }, [onClick, suggestion]);
  return /*#__PURE__*/_jsx(StyledRow, {
    "aria-selected": isSelected,
    className: "p-x-4 align-center",
    onClick: handleClick,
    children: /*#__PURE__*/_jsxs(UIBox, {
      className: "align-center",
      grow: 1,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: icon || 'blank',
        color: isSelected ? THUNDERDOME : EERIE,
        size: 18,
        className: "m-right-2 display-block p-top-1"
      }), /*#__PURE__*/_jsx("p", {
        className: "row-text m-bottom-0",
        children: label
      })]
    })
  });
};
export default EPSpotlightSuggestion;